module.exports = __webpack_public_path__ + "footer.9bee321f0edc469e0465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer.png
// module id = 690
// module chunks = 2